/* eslint-disable no-unused-vars */
import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Grid, Box } from '@mui/material';
import styled, { keyframes } from 'styled-components';
import Students from "../assets/students.svg";
import { LightBlueButton } from '../components/buttonStyles';

const Homepage = () => {
    return (
        <StyledContainer>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <ImageContainer>
                        <AnimatedImage src={Students} alt="students" />
                    </ImageContainer>
                </Grid>
                <Grid item xs={12} md={6}>
                    <StyledPaper>
                        <StyledTitle>
                            Welcome to
                            <br />
                            <GradientText>School Management</GradientText>
                            <br />
                            System
                        </StyledTitle>
                        <StyledText>
                            Streamline school management, class organization, and add students and faculty.
                            Seamlessly track attendance, assess performance, and provide feedback.
                            Access records, view marks, and communicate effortlessly.
                        </StyledText>
                        <StyledBox>
                            <StyledLink to="/choose">
                                <StyledButton variant="contained" fullWidth>
                                    Login
                                </StyledButton>
                            </StyledLink>
                        </StyledBox>
                    </StyledPaper>
                </Grid>
            </Grid>
        </StyledContainer>
    );
};

export default Homepage;

const StyledContainer = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #004d40, #b8860b);
  padding: 20px;
`;

const StyledPaper = styled.div`
  padding: 24px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  text-align: center;
  transition: transform 0.3s ease-in-out;
  &:hover {
    transform: scale(1.02);
    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.25);
  }
`;

const StyledBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
`;

const GradientText = styled.span`
  background: linear-gradient(135deg, #b8860b, #ffd700);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-weight: bold;
`;

const StyledTitle = styled.h1`
  font-size: 2.5rem;
  color: #004d40;
  font-weight: 700;
  margin-bottom: 16px;
`;

const StyledText = styled.p`
  font-size: 1.1rem;
  color: #333;
  line-height: 1.6;
  padding: 10px;
  border-radius: 8px;
  background: rgba(184, 134, 11, 0.1);
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  width: 100%;
  max-width: 250px;
`;

const StyledButton = styled(LightBlueButton)`
  background: linear-gradient(135deg, #b8860b, #ffd700);
  color: white;
  font-weight: 600;
  padding: 14px 24px;
  border-radius: 10px;
  transition: all 0.3s ease;
  &:hover {
    transform: scale(1.08);
    background: linear-gradient(135deg, #ffd700, #b8860b);
    box-shadow: 0px 4px 15px rgba(255, 215, 0, 0.5);
  }
`;

const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-12px); }
  100% { transform: translateY(0px); }
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

const AnimatedImage = styled.img`
  width: 80%;
  max-width: 400px;
  animation: ${float} 3s ease-in-out infinite;
  filter: drop-shadow(0 12px 22px rgba(184, 134, 11, 0.3));
`;